import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import './MobileDirectory.scss';
import UserAvatar from '../../components/UserAvatar';
import CollectionDataSource from '../../dao/DataSource/CollectionDataSource';
import ABCScroller from '../../components/ABCScroller';
import Input from '../../components/Input';

export class MobileDirectory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      directories: null,
      users: null,
    };
    this.onSearchTextChange = this.onSearchTextChange.bind(this);
    this.searchCancel = this.searchCancel.bind(this);
    this.createUserList = this.createUserList.bind(this);
    this.goToUserProfile = this.goToUserProfile.bind(this);
    this.handleUpdateUsers = this.handleUpdateUsers.bind(this);
  }

  handleUpdateUsers(users) {
    if (users) {
      users.users.sort((u1, u2) => {
        if (u1.name < u2.name) {
          return -1;
        }
        else if (u1.name > u2.name) {
          return 1;
        }
        else {
          return 0;
        }
      });
      let sortedUsers = users.users;
      if (this.state.searchString) {
        sortedUsers = sortedUsers.filter(user => {
          return user.first_name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1 ||
            user.last_name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1 ||
            (user.first_name + ' ' + user.last_name).toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1;
        });
      }
      this.setState({ users, sortedUsers });
    }
  }

  componentDidMount() {
    this.usersDataSource = new CollectionDataSource('UsersCollection', 'User', { users: { additionalFields: ['profile_image'] } },
      this.handleUpdateUsers, 'MobileUsers',
    null, null, null, null, null, null, true);
    this.usersDataSource.current();
  }

  componentWillUnmount() {
    if (this.usersDataSource)
      this.usersDataSource.release();
    this.usersDataSource = null;
    if (this.vendorUsersDataSource)
      this.vendorUsersDataSource.release();
    this.vendorUsersDataSource = null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchString != this.state.searchString) {
      let filteredUsers = this.state.users.users;
      if (this.state.searchString) {
        filteredUsers = filteredUsers.filter(user => {
          return user.first_name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1 ||
            user.last_name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1 ||
            (user.first_name + ' ' + user.last_name).toLowerCase().indexOf(this.state.searchString.toLowerCase()) != -1;
        });
      }
      this.setState({ sortedUsers: filteredUsers });
    }
  }

  onSearchTextChange(e) {
    this.setState({ searchString: e.target.value });
  }

  searchCancel() {
    this.setState({ searchString: null });
  }

  goToUserProfile(e) {
    const userId = e.currentTarget.id;
    if (userId) {
      this.props.history.push('/mobile/users/' + userId);
    }
  }

  createUserList() {
    const { sortedUsers } = this.state;
    if (sortedUsers && sortedUsers.length) {
      return sortedUsers.map(user => {
        return (
          <div className="user-entry" key={user.id} id={user.id} onClick={this.goToUserProfile}>
            <UserAvatar user={user} extraLarge={true} />
            <div className="user-name ">{user.name ? user.name : user.first_name + ' ' + user.last_name}</div>
            <div className="click-through-arrow" />
          </div>
        );
      });
    }
  }

  render() {
    if (!this.state.users && !this.state.vendorUsers) {
      return null;
    }
    return (
      <div className="mobile-directory">
        <ABCScroller viewPort={'usersContainer'} itemList={this.state.sortedUsers}
          itemIdKey={'id'} itemKey={'name'} />
        <div className="search-bar">
          <div className="search-icon" />
          <div className="search-input">
          <Input className='search-input' type="text" value={this.state.searchString} placeholder={'User Name'} onChange={this.onSearchTextChange}/>
          </div>
        </div>
            
        <div id='directoryScroller' className="directory-scroller">
          <div id='usersContainer' className="users-container">
            {this.createUserList()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};
export default withRouter(connect(mapStateToProps)(MobileDirectory));



// WEBPACK FOOTER //
// ./src/containers/MobileDirectory/index.js